import axios from "axios";
import { loginSuccess, logoutUserSuccess, apiError, AuthError, reset_login_flag } from './reducer';

// const fireBaseBackend = getFirebaseBackend();

export const loginUser = (user: any, history: any) => async (dispatch: any) => {
    try {

        let data = {
            action: "auth",
            user: user.email,
            pass: user.password,
        };
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            //baseURL: `https://sip${user.server}.trendpbx.com`,
            url: '/apiV2/',
            headers: {
                'Content-Type': 'text/plain'
            },
            data: data
        };

        await axios.request(config).then(
            (data: any) => {
                if (!data.userinfo)
                    dispatch(AuthError("Email ou mot de passe invalide. Veuillez r�essayer"));
                else {
                    var finallogin: any = JSON.stringify(data);
                    finallogin = JSON.parse(finallogin);
                    dispatch(loginSuccess(finallogin));
                    history('/caisse')
                }
            }
        ).catch(
            error => {
                dispatch(AuthError("Email ou mot de passe invalide. Veuillez r�essayer"));
            }
        );

    } catch (error: any) {
        dispatch(AuthError("Erreur de connexion"));
    }
};


export const logoutUser = () => async (dispatch: any) => {
    try {
        localStorage.removeItem("authUser");
        dispatch(logoutUserSuccess(true));
    } catch (error: any) {
        dispatch(apiError(error));
    }
};


export const checkTokenExpiration = (navigate: (path: string) => void) => {
    try {
        const authUser = localStorage.getItem("authUser");

        if (!authUser) {
            return;
        }

        let parsedAuthUser;
        try {
            parsedAuthUser = JSON.parse(authUser);
        } catch (error) {
            return;
        }

        const expirationTime = parsedAuthUser.expiration_time;
        const currentTime = Math.floor(Date.now() / 1000); // Unix timestamp in seconds



        if (typeof expirationTime !== "number" || isNaN(expirationTime)) {
            return;
        }

        if (currentTime >= expirationTime) {
            localStorage.clear();
            navigate("/login");
        } else {
        }
    } catch (error) {
    }
};




export const resetLoginFlag = () => async (dispatch: any) => {
    try {
        const response = dispatch(reset_login_flag());
        return response;
    } catch (error: any) {
        dispatch(apiError(error));
    }
};